export const getCountyNameFromIncludes = ({ included, secGeogs }) => {
  const countyId = secGeogs?.data[0]?.id;
  if (countyId) {
    return included?.find((el) => el.id === countyId)?.attributes?.name || '';
  }
  return '';
};
